import { render, staticRenderFns } from "./Baidu.vue?vue&type=template&id=3831132d&scoped=true"
import script from "./Baidu.vue?vue&type=script&lang=js"
export * from "./Baidu.vue?vue&type=script&lang=js"
import style0 from "./Baidu.vue?vue&type=style&index=0&id=3831132d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3831132d",
  null
  
)

export default component.exports